import React from 'react';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton/IconButton";
import withWidth from "@material-ui/core/withWidth/withWidth";
import InfoIcon from "@material-ui/icons/Info";
import * as Logger from "./Logger";


// TODO, styles are not working here ...
const styles = theme => ({
    button: {
        marginTop: 6,
        paddingBottom: 6,
    }
});

function Logo(props) {
    const classes = { props }
    const [showAll, setShowAll] = React.useState(false);


    const logoSmallProject = <img style={{ marginLeft: "10px", height: "60px" }} src="./img/logoProjectSm.png" />;
    const logoSmallRest = <img style={{ marginLeft: "10px", height: "60px" }} src="./img/logoPartnersSm.png" />
    const logoSmallAll = (<React.Fragment>{logoSmallRest}{logoSmallProject}</React.Fragment>)

    const layoutSize = (props.width === "lg" || props.width === "xl" ? "l" :
        props.width === "sm" || props.width === "xs" ? "s" : "m")


    function handleIconClick() {
        Logger.log("Icon Clicked");
        setShowAll(!showAll);
    }
    Logger.log("layout size icon " + layoutSize)
    // mobile app, show only project logo and on click show rest logos
    if (layoutSize === "s") {
        return <IconButton className={classes.button} aria-label="Icon" style={{ paddingTop: 6, paddingBottom: 6 }}
            onClick={handleIconClick}>
            {showAll && (logoSmallAll)}
            {!showAll && <InfoIcon />}
        </IconButton>;
    } else
        return "";

}

export default withWidth()(withStyles(styles)(Logo));
